import { Injectable, inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { AccountingFacade } from "../../accounting/accounting.facade";
import { PayrollFacade } from "../../payroll/payroll.facade";
import { LoadDashboard, LoadTransactions, UpdateFilter } from "../state/home.actions";
import { HomeState } from "../state/home.state";

@Injectable({ providedIn: 'root' })
export class DashboardFacade {
    private store = inject(Store);

    transactions$ = this.store.select(HomeState.transactions);
    summary$ = this.store.select(HomeState.summary);
    filter$ = this.store.select(HomeState.filter);
    filter = this.store.selectSnapshot(HomeState.filter);

    constructor(
        private payroll: PayrollFacade,
        private accounting: AccountingFacade,
    ) { }

    updateFilter(from: Date, to: Date) {
        this.store.dispatch(new UpdateFilter(from, to));
    }

    refresh() {
        const { from, to } = this.store.selectSnapshot(HomeState.filter) || {};

        if (from && to) {
            return this.loadAccounting(from, to);

        }

    }

    loadAccounting(from: Date, to: Date) {
        this.store.dispatch(new LoadDashboard(from, to));
    }

    loadContractors() {
        this.payroll.loadContractors();
        this.accounting.loadCategories();
    }
}